var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDraftActive = function SvgDraftActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.776 2H3.338c-.74 0-1.339.603-1.333 1.343l.069 9.334c.005.732.6 1.323 1.333 1.323h9.254c.737 0 1.334-.597 1.334-1.333V5.219c0-.354-.141-.693-.391-.943l-1.885-1.885c-.25-.25-.589-.391-.943-.391",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.662 2v2.606a.667.667 0 0 1-.667.667h-4a.667.667 0 0 1-.666-.667V2M4.667 14V8.857c0-.473.384-.857.857-.857h4.953c.472 0 .856.384.856.857V14"
  })));
};
export { SvgDraftActive as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOWNjOTEwNTc1ZGI5MjJkZTdjMDU0MjNiMDZlYWY3YjMuc3ZnIjs=";